<template>
    <div class="page-wrapper">
        <SuccessMessage/>
        <div class="level m-t-md m-b-md">
            <div class="level-left">
                <div class="level-item">
                    <span class="title">Releases</span>
                </div>
            </div>
        </div>
        <div class="flex-wrap page-content">
            <div class="release-filters m-b-md">
                <div class="level">
                    <div class="level-item level-left">
                        <div class="buttons">
                            <b-button
                                type="is-info m-r-sm"
                                @click.prevent="goToCreateRelease()"
                            v-if="isRole('serviceperson')">Announce Release</b-button>
                            <b-button
                                :type="status == 'pending' ? 'is-info m-r-sm active' : 'is-info m-r-sm'"
                                @click.prevent="status = 'pending', getReleases(1)"
                            >Developing</b-button>
                            <b-button
                                :type="status == 'deployed' ? 'is-success m-r-sm active' : 'is-success m-r-sm'"
                                @click.prevent="status = 'deployed', getReleases(1)"
                            >Released</b-button>
                            <b-button
                                :type="status == 'void' ? 'is-dark m-r-sm active' : 'is-dark m-r-sm'"
                                @click.prevent="status = 'void', getReleases(1)"
                                v-if="isRole('serviceperson') || isRole('developer')"
                            >Void</b-button>
                        </div>
                    </div>
                    <div class="level-item level-right">
                        <app-filter v-model="appSelected" @input="getReleases(1)" :nullable="true"/>
                    </div>
                </div>

            </div>
            <div class="flex-1" id="scroller">
                <b-table :data="releases" :loading="loading"
                    :sticky-header="true"
                    :row-class="() => 'row-releases'">
                    <template slot-scope="props">

                        <b-table-column
                            field="id"
                            label="Release"
                        >{{ props.row.id | makeIDSixDigits }}</b-table-column>

                        <b-table-column
                            field="app"
                            label="Application"
                        >
                            {{props.row.attributes.app}}
                        </b-table-column>

                        <b-table-column
                            field="name"
                            label="Description"
                        >{{ props.row.attributes.name }}</b-table-column>

                        <!--
                        <b-table-column
                            field="details"
                            label="Details"
                            class="ellipsis"
                        >{{ props.row.attributes.details }}</b-table-column>
                        -->

                        <b-table-column
                            field="status"
                            label="Status"
                        >{{ props.row.attributes.status.toUpperCase() }}</b-table-column>

                        <b-table-column field="id" class="minimum-possible">
                            <button
                                class="button is-small m-l-sm"
                                @click.prevent="edit(props.row.id)"
                            >EDIT</button>
                        </b-table-column>

                    </template>

                    <!-- If Empty -->
                    <template slot="empty">
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p>
                                    <b-icon icon="alert-decagram-outline" size="is-large"></b-icon>
                                </p>
                                <p>[NO RELEASE DATA]</p>
                            </div>
                        </section>
                    </template>
                </b-table>
                <hr>
                <b-pagination v-if="pagination.total>=1000"
                    :total="pagination.total"
                    :current.sync="pagination.currentPage"
                    :order="pagination.order"
                    :size="pagination.size"
                    :simple="false"
                    :rounded="false"
                    :per-page="pagination.perPage"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import appFilter from '../../../components/AppFilter.vue'

export default {
    components:{
        appFilter
    },
    data() {
        return {
            loading: false,
            releases: [],
            status: "pending",
            relationship:[],
            pagination: {
                total: 0,
                currentPage: 1,
                perPage: 0,
                order: "default",
                size: "default"
            },
            appSelected:null
        };
    },
    watch: {
        "pagination.currentPage"(value) {
            this.loading = true;
            this.getReleases(value);
        }
    },
    mounted() {
        this.loading = true;
        this.getReleases(1);
        this.appSelected = this.$store.state.appSelected
    },
    beforeDestroy() {
        this.$store.commit("SET_SUCCESS_MESSAGE", null);
        this.$store.commit("SET_ERRORS", null);
    },
    methods: {
        getReleases(page) {
            let params = `?page=${page ? page : 1}&status=${this.status}`;
            if(this.appSelected){
                params+=`&app_id=${this.appSelected}`
            }
            Vue.$releaseService.releaseList(params).then(response => {
                this.releases = response.data;
                this.relationship = response.included
                this.pagination.total = response.meta.pagination.total;
                this.pagination.currentPage =
                    response.meta.pagination.current_page;
                this.pagination.perPage = response.meta.pagination.per_page;
                this.loading = false;
                this.loading = false;
            });
        },

        goToCreateRelease() {
            this.$router.push({
                name: "releases.create"
            });
        },
        edit(id) {
            this.$router.push({
                name: "releases.edit",
                params: {
                    id: id
                }
            });
        }
    }
};
</script>